import { Snackbar } from '@material-ui/core';
import React, { createContext, FC, useContext, useState } from 'react';

interface ContextType {
  snackbar: React.ReactNode | undefined;
  setSnackbar: React.Dispatch<React.SetStateAction<React.ReactNode | undefined>>;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Context = createContext<ContextType>({
  snackbar: undefined,
  setSnackbar: () => undefined,
  setOpen: () => false,
});

const SnackbarProvider: FC = ({ children }) => {
  const [snackbar, setSnackbar] = useState<React.ReactNode | undefined>();
  const [open, setOpen] = React.useState(false);

  const handleClose = (_: any, reason: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <Context.Provider value={{ snackbar, setSnackbar, setOpen }}>
      {children}
      {snackbar && (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <>{snackbar}</>
        </Snackbar>
      )}
    </Context.Provider>
  );
};

export default SnackbarProvider;

// Hooks
export const useShowSnackbar = () => {
  const { setSnackbar, setOpen } = useContext(Context);
  return (snackbar: React.ReactNode) => {
    setSnackbar(snackbar);
    setOpen(true);
  };
};
